exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-cost{text-transform:lowercase;background:#333;color:#fff;border-radius:.6666em;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;padding:.3333em;margin:-.3333em .25em}", ""]);

// exports
